// src/slices/auditLogs/thunk.ts
// Async thunks for Audit Logs

import { createAsyncThunk } from '@reduxjs/toolkit';
import { getAuditLogs, getAuditLogModules } from 'helpers/fakebackend_helper';
import { GetAuditLogsParams } from 'pages/AuditLogs/types';
import { createScreenText } from 'helpers/screenText';
const st = createScreenText('audit_logs_messages');

export const fetchAuditLogs = createAsyncThunk(
  'AuditLogs/fetchAuditLogs',
  async (params: GetAuditLogsParams, { rejectWithValue }) => {
    try {
      const response = await getAuditLogs(params);
      return response.data || response;
    } catch (error: any) {
      return rejectWithValue(
        error?.message || st('co_loi_xay_ra_khi_tai_message')
      );
    }
  }
);

// Danh sách Module hiện đang có trong AuditLog (distinct) — đổ dropdown filter "Module"
export const fetchAuditLogModules = createAsyncThunk(
  'AuditLogs/fetchAuditLogModules',
  async (_: void, { rejectWithValue }) => {
    try {
      const response = await getAuditLogModules();
      return (response.data || response) as string[];
    } catch (error: any) {
      return rejectWithValue(
        error?.message || st('co_loi_xay_ra_khi_tai_message_2')
      );
    }
  }
);